import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import * as DOMPurify from 'dompurify';
import TopBuildInputField from "./InputField";

class TopBuildInput extends React.Component {
  render() {
    return (
      <Row className={DOMPurify.sanitize(this.props.className)}>
        {!this.props.showInvoiceAmountField && <Col md={3} />}  
        <Col md={this.props.showInvoiceAmountField ? 12 : 6}>
          <TopBuildInputField
            isTopBuildInvoice={this.props.isTopBuildInvoice}
            isRequired={this.props.isRequired}
            isNumber={this.props.isNumber}
            showDropDown={this.props.showDropDown}
            isDropdownField={this.props.isDropdownField}
            dropDownValues={this.props.dropDownValues}
            formSetState={this.props.formSetState}
            label={this.props.label}
            name={DOMPurify.sanitize(this.props.name)}
          />
        </Col>
        {!this.props.showInvoiceAmountField && <Col md={3} />}  
      </Row>
    );
  }
}

export default TopBuildInput;
